import React from 'react';

import { useFormContext } from 'react-hook-form';

import { z } from 'zod';

import { AcAdvancedTextInput } from 'components/AcAdvancedTextInput/AcAdvancedInput';
import { FormControl, FormField, FormItem, FormMessage } from 'components/ui';

import { templateStudioSchema } from '../../../validation-schema';

export const TemplateStudioRichTextForm: React.FC = () => {
  const { control, watch } =
    useFormContext<z.infer<typeof templateStudioSchema>>();

  return (
    <FormField
      control={control}
      name="richText"
      render={({ field: { value, onChange } }) => (
        <FormItem>
          <FormControl>
            <AcAdvancedTextInput
              value={value?.text || ''}
              setValue={(newText) => {
                const currentRichText = watch('richText');

                onChange({
                  ...currentRichText,
                  text: newText
                });
              }}
              error={false}
              enableColorPicker={true}
              fontColor={value?.fontColor || 'rgb(0, 0, 0)'}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
